var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailFieldIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Left Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.6667 4.66667L8.67267 8.48467C8.46926 8.60281 8.23822 8.66504 8.003 8.66504C7.76778 8.66504 7.53674 8.60281 7.33333 8.48467L1.33333 4.66667M2.66667 2.66667H13.3333C14.0697 2.66667 14.6667 3.26362 14.6667 4V12C14.6667 12.7364 14.0697 13.3333 13.3333 13.3333H2.66667C1.93029 13.3333 1.33333 12.7364 1.33333 12V4C1.33333 3.26362 1.93029 2.66667 2.66667 2.66667Z",
    stroke: "#8A9896",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailFieldIcon);
export default __webpack_public_path__ + "static/media/email-field-icon.31e455f6b803047e00984461389a148a.svg";
export { ForwardRef as ReactComponent };